import { lazy } from "react";
import { IRoute } from "./types";

const Machine = lazy(() => import("pages/machine"));

const machineRoutes: IRoute[] = [
  {
    key: "choice",
    path: "choice",
    component: <Machine />,
    
  },
];

export default machineRoutes;
